module.exports = __webpack_public_path__ + "img/douyin1.75919de9.png";